import { Box } from "@material-ui/core";
import { ArrowsDownUp } from "phosphor-react";
import {
  clampPlayerWrapperHeightPx,
  DATA_VIEW_SHOT_HEADER_HEIGHT_PX,
} from "./sequencerDataViewLayout";
import useDataViewStyles from "./SequencerMixDataView.styles";

const SequencerMixResizableDivider = ({
  panelRef,
  scrollContainerRef,
  rightColRef,
  onHeightChange,
}) => {
  const classes = useDataViewStyles();

  const handleMouseDown = (e) => {
    e.preventDefault();
    const panel = panelRef.current;
    const scrollContainer = scrollContainerRef.current;
    const rightCol = rightColRef.current;
    if (!panel || !scrollContainer || !rightCol) return;

    const rightColHeight = rightCol.getBoundingClientRect().height;

    const onMouseMove = (moveEvent) => {
      const wrapperHeight =
        moveEvent.clientY -
        panel.getBoundingClientRect().top +
        scrollContainer.scrollTop -
        DATA_VIEW_SHOT_HEADER_HEIGHT_PX;
      onHeightChange(clampPlayerWrapperHeightPx(wrapperHeight, rightColHeight));
    };

    const onMouseUp = () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };

    document.body.style.cursor = "row-resize";
    document.body.style.userSelect = "none";
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
  };

  return (
    <Box className={classes.resizableDivider} onMouseDown={handleMouseDown}>
      <Box className={classes.resizableDividerHandle}>
        <ArrowsDownUp size={14} color="#6C65D9" weight="bold" />
      </Box>
    </Box>
  );
};

export default SequencerMixResizableDivider;
